import { useEffect, useState } from 'react';

/**
 * Forces a re-render on a fixed interval. Used by the kitchen display so
 * each OrderTicket's elapsed-time readout stays current without per-card
 * timers.
 */
export function useTicker(intervalMs = 1000): number {
  const [tick, setTick] = useState(0);
  useEffect(() => {
    const id = setInterval(() => {
      setTick((t) => t + 1);
    }, intervalMs);
    return () => {
      clearInterval(id);
    };
  }, [intervalMs]);
  return tick;
}
